import React from 'react';
import Modal from 'react-modal';
import './style.scss';

Modal.setAppElement('#root');
type ModalBaseProps = {
  isOpen: boolean;
  modalStyle: ModalStyle;
  onRequestClose?: (e: React.KeyboardEvent) => void;
  onAfterOpen?: () => void;
  children?: React.ReactNode;
  shouldCloseOnOverlayClick?: boolean;
};

export enum ModalStyle {
  confirmModal,
  completeModal,
}

const getContentStyle = (type: ModalStyle) => {
  switch (type) {
    case ModalStyle.confirmModal:
      return 'confirmContent';
    case ModalStyle.completeModal:
      return 'completeContent';
  }
};

export const ModalBase = (props: ModalBaseProps) => {
  const { isOpen, modalStyle, onRequestClose, onAfterOpen, children, shouldCloseOnOverlayClick } = props;

  return (
    <Modal
      isOpen={isOpen}
      overlayClassName="modalOverLay"
      className={getContentStyle(modalStyle)}
      onRequestClose={(e: React.KeyboardEvent) => onRequestClose && onRequestClose(e)}
      onAfterOpen={onAfterOpen}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    >
      {children}
    </Modal>
  );
};
